export default {

    methods: {

        formatLiteralIntegerToDay( integer ){

            switch( integer ){

                case 1:
                case 21:

                    return `${integer}st`;
                case 2:
                case 22:

                    return `${integer}nd`;
                case 3:
                case 23:

                    return `${integer}rd`;
                default:

                    return `${integer}th`;
            }
        },

        formatDate(date, format='MM/DD/YYYY', fromFormat = null) {
            return moment(date, fromFormat).format(format);
        },

        formatDateFromUTC(date, format='MM/DD/YYYY', fromFormat = null) {
            return moment.utc(date, fromFormat).local().format(format);
        },

        formatTime(dateTime, format='h:mm a', fromFormat = null) {
            return this.formatDate(dateTime, format, fromFormat);
        },

        formatTimeFromUTC(dateTime, format='h:mm a', fromFormat = null) {
            return this.formatDateFromUTC(dateTime, format, fromFormat);
        },

        formatTimeFromUTCToTimezone(dateTime, format= 'MM/DD/YYYY h:mm A z', timezone = 'America/Chicago') {
            return moment(dateTime).utc().tz(timezone).format(format);
        },

        formatDateTime(dateTime, format='MM/DD/YYYY h:mm a', fromFormat=null) {
            return this.formatDate(dateTime, format, fromFormat);
        },

        formatDateTimeFromUTC(dateTime, format='MM/DD/YYYY h:mm a', fromFormat=null) {
            return this.formatDateFromUTC(dateTime, format, fromFormat);
        },

        getLocalTimezoneOffset() {
            return moment().format('ZZ');
        },

        formatHours(hours) {
            if (! hours) {
                return '-';
            }
            let convertHours = Math.floor(hours);
            let minutes = Math.round((hours - convertHours) * 60);

            return `${convertHours}h ${minutes}m`;
        },

        formatDateMDYtoYMD(s) {
            s = ' ' + s;
            s = s.trim().substring(0, 10);            

            if (s.length !== 10)
                return '';

            s = s.split('/');

            if (s.length !== 3)
                return '';

            let [m, d, y] = s;

            return [y, m, d].join('-');
        },

        validateAndGetDayMDY(s) {
            /**
             * Accepts a string validates if it's in format MM/DD/YYYY 
             * return empty string if invalid
             * If valid 
             * return Day, Month Date(th) Year 
             * E.g Monday, Nov 25th 2022
             */
            let date = moment(s, 'MM/DD/YYYY', true);
        
            return date.isValid() ?
                        date.format('dddd, MMM Do YYYY') :
                        '';
        },

        getMomentFromMDY(date) {
            date = moment(date, 'MM/DD/YYYY', true); 

            return date.isValid()? date : false; 
        },

        /**
         * Converts a date from YMD to MDY
         * @param {String} s - Date or DateTime starting with YYYY-MM-DD 
         * @returns {String} Date in MM/DD/YYYY
         */
        convertDateYmdToMdy(s) {

            s = ' ' + s;
            s = s.trim().substring(0, 10);            

            if (s.length !== 10)
                return '';

            s = s.split('-');

            if (s.length !== 3)
                return '';

            let [y, m, d] = s;

            return [m, d, y].join('/');
        },

        checkIfDateInRange(label='', date='', range = ['', '']) {
            /**
             * Args:
             *      label   => Date label such as From / To
             *      s       => String - Date to validate MM/DD/YYYY
             *      range   => Array String - [min, max]
             *          min => String [Optional] - Date MM/DD/YYYY - Lower Limit
             *          max => String [Optional] - Date MM/DD/YYYY - Upper Limit
             * 
             * Returns Object {
             *      valid: Boolean,
             *      class: String // CSS class
             *      message: String // Error Message OR Valid Day, Month Date(th) Year,
             *      replaceWith: Date to be replaced with either min or max when date is empty or out of bounds
             * }
             */
            
            let [min, max] = range;

            let replaceWith = min ? min : max ? max : '';

            let minDate = min ? this.getMomentFromMDY(min) : false;
            let maxDate = max ? this.getMomentFromMDY(max) : false;
               
            // If date is NOT passed then minDate or maxDate will be returned as replace value
            if (!date) {
                if (minDate) 
                    return {
                        valid: false,
                        class: 'text-success',
                        message: minDate.format('dddd, MMM Do YYYY'),
                        replaceWith: min
                    };
                
                if (maxDate)
                    return {
                        valid: false,
                        class: 'text-success',
                        message: maxDate.format('dddd, MMM Do YYYY'),
                        replaceWith: max
                    };

                return {
                    valid: false,
                    class: 'text-info',
                    message: `${label} Date is required`,
                    replaceWith
                };
            }
            
            date = this.getMomentFromMDY(date);

            // Invalid Date
            if (date === false)
                return {
                    valid: false,
                    class: 'text-danger',
                    message: 'Format must be MM/DD/YYYY',
                    replaceWith
                };
                
            // Date earlier than minDate
            if (minDate && (date < minDate))
                return {
                    valid: false,
                    class: 'text-danger',
                    message: `${label} Date cannot be earlier than ${min}`,
                    replaceWith: min
                };

            // Date later than maxDate
            if (maxDate && (date > maxDate))
                return {
                    valid: false,
                    class: 'text-danger',
                    message: `${label} Date cannot be later than ${max}`,
                    replaceWith: max
                };
            
            return {
                valid: true,
                class: 'text-success',
                message: date.format('dddd, MMM Do YYYY')
            };
        }
    }
}